import { Connector } from '@lair-finance/wagmi/core'

export function isMetaMaskConnector(connector: Connector) {
  return ['metaMask', 'io.metamask'].includes(connector.id)
}

export function isKaiaConnector(connector: Connector) {
  return ['kaia'].includes(connector.id)
}

export function isKaikasConnector(connector: Connector) {
  return ['kaikas'].includes(connector.id)
}
